import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { Asset, AssetLocation } from './asset';
import { EntityType } from '../comment';

export class AssetInput extends Asset implements EntityInput<Asset> {
  constructor(obj: any) {
    super(obj);
  }

  forCreate(): CreateAssetInput {
    delete (this.product as any).reservedUnitQuantity;
    delete (this.product as any).reservedQuantity;
    delete (this as any).authorization;
    return { ...this, product: { ...this.product, customFields: this.product.customFieldValues() } };
  }

  forUpdate(): UpdateAssetInput {
    delete (this.product as any).reservedUnitQuantity;
    delete (this.product as any).reservedQuantity;
    delete (this as any).authorization;
    (this as any).product.customFields = this.product.customFieldValues();
    return UpdateAssetInput.from(
      { ...this, product: { ...this.product, customFields: this.product.customFieldValues() } },
      UpdateAssetInput,
    );
  }

  forDelete(): DeleteAssetInput {
    delete (this.product as any).reservedUnitQuantity;
    delete (this.product as any).reservedQuantity;
    delete (this as any).authorization;
    (this as any).product.customFields = this.product.customFieldValues();
    return DeleteAssetInput.from(
      { ...this, product: { ...this.product, customFields: this.product.customFieldValues() } },
      DeleteAssetInput,
    );
  }

  validate() {
    if (!this.product.productMasterDataId) return false;
    if (!this.product.quantity) return false;
    return true;
  }

  withProductMasterDataId(pmdId: string | undefined | null) {
    if (!pmdId) {
      this.product.productMasterDataId = '';
    } else {
      this.product.productMasterDataId = pmdId;
    }
    return cloneDeep(this);
  }

  withUserId(userId: string | undefined | null) {
    if (!userId) {
      this.location = undefined;
    } else {
      this.location = new AssetLocation(userId, EntityType.user);
    }
    return cloneDeep(this);
  }

  withSerial(serial?: string) {
    if (serial) this.withQuantity(1);
    this.product.serial = serial;
    return cloneDeep(this);
  }

  withQuantity(quantity: number) {
    this.product.quantity = quantity;
    return cloneDeep(this);
  }
}

export class CreateAssetInput extends forCreate(AssetInput) {}

export class UpdateAssetInput extends forUpdate(AssetInput) {}

export class DeleteAssetInput extends forDelete(AssetInput) {}
